//src/app/features/services/cartItemCard/index.tsx
import { useDeleteCartItemMutation } from 'app/services/payments/cart';
import { Cart } from 'app/services/responseTypes';
import DeleteButton from 'Components/Buttons/DeleteButton';
import { successToast, errorToast } from 'Components/Notifications';

export interface IOrderItemProps {
  Cart: Cart;
  type: 'Project' | 'Service';
}

const CartItemCard = ({ Cart, type }: IOrderItemProps) => {
  const [DeleteCartItem] = useDeleteCartItemMutation();

  return (
    <div className="pb-4 px-4 overflow-auto max-h-64">
      {Cart?.cart_items.map((cart) => (
        <div
          key={cart.id}
          className="border border-white rounded-3xl  shadow-lg px-8 py-4 my-4"
        >
          <div className="flex justify-between">
            <div>
              <p className=" font-semibold text-gray-dark text-base">
                {cart.product.title}
              </p>
              <span className=" inline-flex">
                <p className=" text-green text-regular  font-semibold">
                  ${cart.price.amount_cents / 100}
                </p>{' '}
                <p className=" text-gray-700  text-xs mt-1">
                  {cart.price.type === 'monthly'
                    ? '/ Month'
                    : cart.price.type === 'yearly'
                    ? '/ Year'
                    : ''}
                </p>
              </span>
            </div>

            <div>
              <DeleteButton
                onClick={() =>
                  DeleteCartItem(cart.id)
                    .unwrap()
                    .then(() =>
                      successToast(
                        `${
                          cart.product.type === 'Service'
                            ? 'Service / Bundle'
                            : 'Tax Return'
                        } has been removed successfully`,
                      ),
                    )
                    .catch((e: { data: { message: string } }) => {
                      errorToast(e.data.message);
                    })
                }
              />
            </div>
          </div>
          <p className="  text-gray-700 text-xs">
            {cart.business ? cart.business.name : cart.product.type}
          </p>
        </div>
      ))}
    </div>
  );
};

export default CartItemCard;
